import React, { useState, useEffect } from 'react';

const LoadingScreen = ({ onComplete }) => {
  const [phase, setPhase] = useState('logo'); // logo -> expand -> done

  useEffect(() => {
    const t1 = setTimeout(() => setPhase('expand'), 600);
    const t2 = setTimeout(() => setPhase('done'), 900);
    const t3 = setTimeout(() => onComplete(), 1000);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, [onComplete]);

  if (phase === 'done') return null;

  return (
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center transition-opacity duration-300 ${
        phase === 'expand' ? 'opacity-0' : 'opacity-100'
      }`}
      style={{ background: '#0A0A0A' }}
    >
      <div className={`transition-all duration-500 ease-out ${
        phase === 'logo' ? 'scale-100 opacity-100' : 'scale-110 opacity-0'
      }`}>
        <img
          src="/zelina-logo.webp"
          alt="Zelina Studios"
          className="h-20 sm:h-28 w-auto"
          width="200" height="80"
          style={{
            animation: 'logoReveal 0.5s ease-out forwards',
          }}
        decoding="async" />
        <div
          className="h-[1px] mx-auto mt-6"
          style={{
            background: 'linear-gradient(90deg, transparent, #D4A843, transparent)',
            animation: 'lineExpand 0.6s ease-out forwards',
          }}
        />
      </div>
    </div>
  );
};

export default LoadingScreen;
